import { Injectable } from "@angular/core";
import { SortDirection } from "@angular/material/sort";

export interface ProposalsListState {
    pageIndex: number;
    pageSize: number;
    sortActive: string;
    sortDirection: SortDirection;
}

@Injectable({
    providedIn: 'root'
})
export class ProposalsState {
    private state: ProposalsListState | null = null;

    saveState(state: ProposalsListState): void {
        this.state = { ...state };
    }

    getState(): ProposalsListState | null {
        const currentState = this.state;
        return currentState ? { ...currentState } : null;
    }

    resetState(): void {
        this.state = null;
    }
}